import WorldIcon from 'components/ReusableComponents/Icons/World'
import useCopyText from 'hooks/useCopyText'
import { useInternalAdmin } from 'hooks'
import { useSelector } from 'react-redux'

import { selectCurrentHotelId } from '../../../accessors'
import { ReactComponent as HubspotIcon } from './hubspot.svg'

const HeaderChecklist = () => {
  const copy = useCopyText()
  const currentHotelId = useSelector(selectCurrentHotelId)
  const isGdsBookingAvailable = useSelector(s => s.hotelDetails.isGdsBookingAvailable)
  const hubspotId = useSelector(s => s.hotelDetails.hubspotId)
  const isInternalAdmin = useInternalAdmin()

  return (
    <>
      <span
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            if (currentHotelId) copy(currentHotelId)
          }
        }}
        onDoubleClick={e => {
          e.stopPropagation()
          if (currentHotelId) copy(currentHotelId)
        }}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
        title="GDS Booking is available. Double-click to copy hotel ID"
      >
        <WorldIcon
          fill={isGdsBookingAvailable ? '#66bb6a' : '#b7babf'}
          width="27px"
          height="27px"
          style={{ position: 'releative', top: '0', marginRight: 6 }}
        />
      </span>
      {isInternalAdmin && (
        <>
          {hubspotId && (
            <a
              href={`https://app.hubspot.com/contacts/3397857/record/0-2/${hubspotId}`}
              target="_blank"
              rel="noreferrer"
              style={{ height: 27 }}
            >
              <HubspotIcon
                fill="#ff7a59"
                width="27px"
                height="27px"
                style={{ position: 'releative', top: '0', marginRight: 12 }}
                title="Hubspot is connected"
              />
            </a>
          )}
          {!hubspotId && (
            <HubspotIcon
              fill="#ff7a59"
              width="27px"
              height="27px"
              style={{
                position: 'releative',
                top: '0',
                marginRight: 12,
                filter: 'grayscale(100%)',
                opacity: 0.7
              }}
              title="Hubspot is connected"
            />
          )}
        </>
      )}
    </>
  )
}

export default HeaderChecklist
